import styles from 'styles/modules/AddContent.module.scss';
import { useSelector } from 'react-redux';
import { authSelector } from 'store/auth';
import Typo from 'components/Typo';

const AddContent = ({ data, className }) => {
    const { isAuthorized } = useSelector(authSelector);

    if (!isAuthorized) {
        return null;
    }

    // Default config
    let config = {
        direction: 'column',
        label: 'Add Content',
        onClick: () => {},
        active: false,
        center: false,
        reverted: false,
        blue: false,
        labelHideMob: false,
    };

    // Merge default config with data from props
    if (data) config = { ...config, ...data };

    const {
        direction,
        active,
        label,
        center,
        reverted,
        blue,
        labelHideMob,
        onClick,
    } = config;

    const classes = [
        styles.wrapper,
        styles[direction],
        active ? styles.active : null,
        !label ? styles.inline : null,
        center ? styles.center : null,
        reverted ? styles.reverted : null,
        blue ? styles.blue : null,
        labelHideMob ? styles.labelHideMob : null,
        className ? className : null,
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <div className={classes} onClick={onClick}>
            <div className={styles.plus} />
            {label && (
                <Typo variant={'small'} className={styles.label}>
                    {label}
                </Typo>
            )}
        </div>
    );
};

export default AddContent;
